import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getErrorMessage } from '../../../../utils/errorMessage';
import { resetPassword } from '../resetPassword.api';
import {
  ModalConfirmationHeader,
  ModalConfirmationFooter,
  ModalConfirmationContent,
  ModalActions,
} from '../../../../components/modal';
import { Loader } from '../../../../components/loader/Loader';
import { TextButton, PrimaryButton } from '../../../../components/button';
import styles from './reset_password_first_step.module.scss';

type Props = {
  closeModal: () => void;
  onSuccess: Function;
};

type State = {
  email: string;
  error: string;
  loading: boolean;
};

export class ResetPasswordFirstStep extends React.Component<Props, State> {
  state: State = { email: '', error: '', loading: false };

  submitResetPassword = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      this.setState({ loading: true });
      await resetPassword(this.state.email);
      this.props.onSuccess();
    } catch (error) {
      this.setState({ error: getErrorMessage(error.response), loading: false });
    }
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ email: event.target.value, loading: false });
  };

  render() {
    const { closeModal } = this.props;
    const { loading } = this.state;
    return (
      <>
        <ModalConfirmationHeader
          title={
            <FormattedMessage id="account/general/reset-password-modal/steps/ResetPasswordFirstStep.tsx/5" />
          }
          onClose={closeModal}
        />
        <form onSubmit={this.submitResetPassword}>
          <ModalConfirmationContent>
            <div className={styles.content}>
              <FormattedMessage id="account/general/reset-password-modal/steps/ResetPasswordFirstStep.tsx/1" />
            </div>
            <div className={styles.content}>
              <label htmlFor="input-email" className={styles.label}>
                <FormattedMessage id="account/general/reset-password-modal/steps/ResetPasswordFirstStep.tsx/2" />
                <input
                  required
                  id="input-email"
                  type="email"
                  value={this.state.email}
                  onChange={this.handleChange}
                  spellCheck={false}
                />
              </label>
            </div>
            {this.state.error && (
              <div className={styles.error}>{this.state.error}</div>
            )}
          </ModalConfirmationContent>
          <ModalConfirmationFooter>
            <ModalActions>
              <TextButton onClick={closeModal}>
                <FormattedMessage id="account/general/reset-password-modal/steps/ResetPasswordFirstStep.tsx/3" />
              </TextButton>
              <PrimaryButton disabled={loading} type="submit">
                <span className={styles.submit}>
                  {loading && (
                    <span className={styles.loading}>
                      <Loader size={18} />
                    </span>
                  )}
                  <FormattedMessage id="account/general/reset-password-modal/steps/ResetPasswordFirstStep.tsx/4" />
                </span>
              </PrimaryButton>
            </ModalActions>
          </ModalConfirmationFooter>
        </form>
      </>
    );
  }
}
